import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import RequireAdmin from "@/components/RequireAdmin";
import RequireAuth from "@/components/RequireAuth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import ScanWizard from "@/pages/ScanWizard";
import Report from "@/pages/Report";
import Dashboard from "@/pages/Dashboard";
import Businesses from "@/pages/Businesses";
import Tasks from "@/pages/Tasks";
import ReputationRecovery from "@/pages/ReputationRecovery";
import Admin from "@/pages/Admin";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import ScanSolutions from "@/pages/ScanSolutions";
import FinancialAnalysis from "@/pages/FinancialAnalysis";
import Proposals from "@/pages/Proposals";
import ProposalDetail from "@/pages/ProposalDetail";
import PublicProposal from "@/pages/PublicProposal";
import Pipeline from "@/pages/Pipeline";
import Payment from "@/pages/Payment";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/scan" element={<ScanWizard />} />
            <Route path="/report/:id" element={<Report />} />
            <Route path="/scan/:id/solutions" element={<ScanSolutions />} />
            <Route path="/scan/:id/financials" element={<RequireAuth><FinancialAnalysis /></RequireAuth>} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/businesses" element={<Businesses />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/reputation" element={<ReputationRecovery />} />

            {/* Customer auth */}
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/forgot-password" element={<Auth mode="forgot" />} />
            <Route path="/reset-password" element={<Auth mode="reset" />} />

            {/* Customer account */}
            <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
            <Route path="/proposals" element={<RequireAuth><Proposals /></RequireAuth>} />
            <Route path="/pipeline" element={<RequireAuth><Pipeline /></RequireAuth>} />
            <Route path="/proposals/:id" element={<RequireAuth><ProposalDetail /></RequireAuth>} />

            {/* Public client-facing proposal + payment result */}
            <Route path="/p/:token" element={<PublicProposal />} />
            <Route path="/payment/success" element={<Payment status="success" />} />
            <Route path="/payment/cancel" element={<Payment status="cancel" />} />

            {/* Legal */}
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="/refund-policy" element={<Legal doc="refund" />} />
            <Route path="/ai-disclaimer" element={<Legal doc="ai-disclaimer" />} />

            {/* Admin */}
            <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          </Routes>
          <Footer />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
